// @flow
import { selectTaxesDisplaySetting } from '@gandi/authentication';

import { useAppSelector } from 'src/hooks/useAppSelector';

// For the prices,
// return the price before or after taxes in function of choice of the user.

type Price = {
  price_after_taxes: number,
  price_before_taxes: number,
  [string]: any,
};
export function useGetPrice(): (price: Price) => number {
  const taxesIncluded = useAppSelector(selectTaxesDisplaySetting);

  return (price: Price) =>
    price[taxesIncluded ? 'price_after_taxes' : 'price_before_taxes'];
}

export function redirectTo(url: string): void {
  window.location.assign(url);
}
